import { PrivateInterceptor } from '../../../interceptors/PrivateInterceptor'


export const getListadoImagenes = async (Codigo) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Imagenes/getTest/` + Codigo, 'GET')
    return respuesta;
}

export const descargarImagenes = async (Codigo, nombre) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Imagenes/getFile/${Codigo}/${nombre}`, 'GET')
    return respuesta;
}
export const mostrarImagenesProductos = async (Codigo, nombre) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Imagenes/getFile/${Codigo}/${nombre}`, 'GET')
    var binary = '';
    var bytes = [].slice.call(new Uint8Array(respuesta.data));
    bytes.forEach((b) => binary += String.fromCharCode(b));
    const base64String = window.btoa(binary);
    return base64String;
}

export const eliminarImagen = async (Codigo, nombre) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Imagenes/deleteFile/${Codigo}/${nombre}`, 'DELETE')
    return respuesta;
}


export const eliminarFoto = async (Codigo, nombre) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Users/deleteFile/Foto/${Codigo}/${nombre}`, 'DELETE')
    return respuesta;
}


// --------------------------------------------------------------FIRMAS--------------------------------------------------------------------

export const eliminarFirma = async (Codigo, nombre) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Users/deleteFile/${Codigo}/${nombre}`, 'DELETE')
    return respuesta;
}

export const descargarFirma = async (Codigo, nombre) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Users/getFile/${Codigo}/${nombre}`, 'GET')
    return respuesta;
}

export const mostrarFirma = async (Codigo, nombre) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Users/getFile/${Codigo}/${nombre}`, 'GET')
    var binary = '';
    var bytes = [].slice.call(new Uint8Array(respuesta.data));
    bytes.forEach((b) => binary += String.fromCharCode(b));
    const base64String = window.btoa(binary);
    return base64String;
}

export const getListadoFirmas = async (Codigo) => {
    const respuesta = await PrivateInterceptor(`Base/IT/Users/getFirma/` + Codigo, 'GET')
    return respuesta;
}